import { Col, Collapse, Row } from "antd";
import React from "react";
import AppContentFieldItem2 from "./app_content_field_item2";
import AppContentFieldItem4 from "./app_content_field_item4";
import "./fund_details_card.css";

const { Panel } = Collapse;

class FundDetailsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }

  stateData() {
    return this.state.data;
  }

  stateFundDetails() {
    return this.stateData();
  }

  componentDidMount() {}

  renderFundDetails(data) {
    if (!data || data.length <= 0) return null;

    let children = [];
    for (var i = 0; i < data.length; i++) {
      let fundList = data[i];
      console.log("fundList",fundList)
      let label1={
        caption: `<b style="color:black">Fund Type</b>`,
        value: "<b>NB</b>"
      }
      let label2={
        caption: "",
        value: "<b>YTD</b>"
      }
      children.push(this.renderTitleRow(this.renderFieldTitle(fundList.name)));
      children.push(this.renderRow(this.renderField(label1,true),this.renderField(label2,false)));
      children.push(<hr style={{marginTop:"-4px",marginBottom:"-4px"}}></hr>)
      children.push(this.renderRow(this.renderField(fundList.initAllocation,true),this.renderField(fundList.allocation,false)));
      children.push(this.renderRow(this.renderField(fundList.initUnit,true),this.renderField(fundList.unit,false)));
      children.push(this.renderRow(this.renderField(fundList.initPricing,true),this.renderField(fundList.pricing,false)));
    }
    return children;
  }

  renderField(field,show) {
    if (field)
      return (
        <AppContentFieldItem2
          title={show ? field.caption :""}
          value={
            field.value == "" || field.value == 0.0 || field.value == null
              ? "N/A"
              : field.value
          }
        />
      );

    return null;
  }

  renderFieldTitle(field) {
    if (field)
      return (
        <AppContentFieldItem4
          title={field.caption}
          value={
            field.value == "" || field.value == 0.0 || field.value == null
              ? "N/A"
              : field.value
          }
        />
      );

    return null;
  }

  renderTitleRow(item1) {
    return (
      <div className="row">
        <div className="col-12">{item1}</div>        
      </div>
    );
  }


  renderRow(item1,item2) {
    console.log("OKKKITEM",item1)
    return (
      <div className="row">
        <div className="col-8">{item1}</div>
        <div className="col-4">{item2}</div>
      </div>
    );
  }

  render() {
    return (
      <div
        className="fund-detail-card"
        bordered={false}
        expandIconPosition={"end"}
        style={{
          backgroundColor:
            this.stateFundDetails() && this.stateFundDetails().length >= 0
              ? "white"
              : "transparent",
          marginBottom: 16,
          marginRight: 16,
          display: this.stateFundDetails().length <= 0 ? "none" : "block",
        }}
        defaultActiveKey={[1]}
      >
        <div
          key={1}
          // header={this.props.caption || ""}
          className="fund-detail-title"
        >
          {this.props.caption && this.state.data.length > 0
            ? this.props.caption
            : ""}
          {this.renderFundDetails(this.stateFundDetails())}
        </div>
        <div className="fund-detail-disclaimer">
         
          {this.props.disclaimer ? `Disclaimer: The pricing for funds is updated as at ${this.props.disclaimer}` :
           ""
           }
        </div>
      </div>
    );
  }
}

export default FundDetailsCard;
